const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    resetPassword: (token) => `${ROOTS.AUTH}/reset-password/${token}`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      attendance: `${ROOTS.DASHBOARD}/user/attendance`,
      payments: `${ROOTS.DASHBOARD}/user/payments`,
      incentives: `${ROOTS.DASHBOARD}/user/incentives`,
    },
    role: {
      root: `${ROOTS.DASHBOARD}/role`,
      new: `${ROOTS.DASHBOARD}/role/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/role/${id}/edit`,
    },
    client: {
      root: `${ROOTS.DASHBOARD}/client`,
      new: `${ROOTS.DASHBOARD}/client/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/clients/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/clients/${id}`,
    },
    jobs: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      proposals: `${ROOTS.DASHBOARD}/proposals/list`,
      proposalDetail: (category, id) => `${ROOTS.DASHBOARD}/proposals/${category}/${id}`,
    },
    location: {
      root: `${ROOTS.DASHBOARD}/location/list`,
      list: `${ROOTS.DASHBOARD}/location/list`,
      new: `${ROOTS.DASHBOARD}/location/create`,
      detail: (id) => `${ROOTS.DASHBOARD}/location/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/location/${id}/edit`,
      bookings: `${ROOTS.DASHBOARD}/location/bookings`,
      availability: `${ROOTS.DASHBOARD}/location/availability`,
    },
    equipment: {
      root: `${ROOTS.DASHBOARD}/equipments/list`,
      list: `${ROOTS.DASHBOARD}/equipments/list`,
      new: `${ROOTS.DASHBOARD}/equipments/add`,
      detail: (id) => `${ROOTS.DASHBOARD}/equipments/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/equipments/${id}/edit`,
      bookings: `${ROOTS.DASHBOARD}/equipments/bookings`,
      availability: `${ROOTS.DASHBOARD}/equipments/availability`,
    },
    applications: {
      root: `${ROOTS.DASHBOARD}/application/applied`,
      applied: `${ROOTS.DASHBOARD}/application/applied`,
      received: `${ROOTS.DASHBOARD}/application/received`,
    },
    application: {
      details: (jobId, candidateShortUrl) => `${ROOTS.DASHBOARD}/application/${jobId}/${candidateShortUrl}`,
      appliedDetails: (applicationId) => `${ROOTS.DASHBOARD}/application/applied/${applicationId}`,
      updateStatus: (jobId, id) => `${ROOTS.DASHBOARD}/application/${jobId}/${id}/status`,
    },
    talent: {
      root: `${ROOTS.DASHBOARD}/talent`,
      new: `${ROOTS.DASHBOARD}/talent/new`,
      list: `${ROOTS.DASHBOARD}/talent`,
      edit: (id) => `${ROOTS.DASHBOARD}/talent/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/talent/${id}`,
      profile: (short_url) => `${ROOTS.DASHBOARD}/talent/profile/${short_url}`,
      hired: `${ROOTS.DASHBOARD}/talent/hired`,
      availability: `${ROOTS.DASHBOARD}/talent/availability`,
      offers: `${ROOTS.DASHBOARD}/talent/offers`,
      offerNew: `${ROOTS.DASHBOARD}/talent/offers/new`,
      bookings: `${ROOTS.DASHBOARD}/talent/bookings`,
      bookingDetails: (id) => `${ROOTS.DASHBOARD}/talent/bookings/${id}`,
    },
    chat: {
      root: `${ROOTS.DASHBOARD}/chat`,
    },
    clients: {
      root: `${ROOTS.DASHBOARD}/clients`,
      new: `${ROOTS.DASHBOARD}/clients/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/clients/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/clients/${id}`,
    },
    agent: {
      root: `${ROOTS.DASHBOARD}/agent`,
      session: (id) => `${ROOTS.DASHBOARD}/agent/${id}`,
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      performa: `${ROOTS.DASHBOARD}/invoice/performa`,
      newperforma: `${ROOTS.DASHBOARD}/invoice/performa/new`,
    },
    projects: {
      root: `${ROOTS.DASHBOARD}/projects`,
      list: `${ROOTS.DASHBOARD}/projects/list`,
      listPayroll: `${ROOTS.DASHBOARD}/projects/members`,
      payoutQueue: `${ROOTS.DASHBOARD}/projects/payoutQueue`,
      new: `${ROOTS.DASHBOARD}/projects/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/projects/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/projects/${id}`,
      kanban: (id) => `${ROOTS.DASHBOARD}/projects/${id}/kanban`,
      calendar: (id) => `${ROOTS.DASHBOARD}/projects/${id}/calendar`,
      analytics: (id) => `${ROOTS.DASHBOARD}/projects/${id}/analytics`,
      allTasks: (id) => `${ROOTS.DASHBOARD}/projects/${id}/all-tasks`,
      attendence: `${ROOTS.DASHBOARD}/projects/attendence`,
      freelancerView: `${ROOTS.DASHBOARD}/projects/freelancerView`,
      incentives: `${ROOTS.DASHBOARD}/projects/incentives`,
    },
    documents: {
      root: `${ROOTS.DASHBOARD}/documents`,
    },
    auditions: {
      root: `${ROOTS.DASHBOARD}/auditions/list`,
      list: `${ROOTS.DASHBOARD}/auditions/list`,
      new: `${ROOTS.DASHBOARD}/auditions/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/auditions/${id}/edit`,
      detail: (id) => `${ROOTS.DASHBOARD}/auditions/${id}`,
    },
    contracts: {
      root: `${ROOTS.DASHBOARD}/contracts`,
      list: `${ROOTS.DASHBOARD}/contracts`,
      templates: `${ROOTS.DASHBOARD}/contracts/templates`,
      detail: (id) => `${ROOTS.DASHBOARD}/contracts/${id}`,
      sign: (id, signingToken) => `${ROOTS.DASHBOARD}/contracts/${id}/sign/${signingToken}`,
    },
    orders: {
      root: `${ROOTS.DASHBOARD}/orders`,
      list: `${ROOTS.DASHBOARD}/orders`,
      details: (id) => `${ROOTS.DASHBOARD}/orders/${id}`,
    },
  },
  contractSign: (signingToken) => `/contract/sign/${signingToken}`,
};
  
